/*
 * SingleClickButton.jsx
 * Created by Harold Rodriguez on 5/18/18.
 */

/* eslint-disable react/no-did-update-set-state */

import React from 'react';
import PropTypes from 'prop-types';


export default class SingleClickButton extends React.PureComponent {
    static propTypes = {
        autoRecover: PropTypes.bool,
        autoRecoverTime: PropTypes.number,
        buttonClass: PropTypes.string,
        children: PropTypes.node,
        onClick: PropTypes.func,
        recovered: PropTypes.bool, // if the button is recovered from being disabled by click
        disabled: PropTypes.bool   // if the button is disabled completely
    };

    static defaultProps = {
        autoRecover: false,
        disabled: false,
        autoRecoverTime: 5000,
        children: 'Submit',
        onClick: () => { },
        buttonClass: 'rec-button-primary'
    };

    state = {
        disabled: this.props.disabled
    };

    componentDidUpdate(prevProps) {
        const { disabled, recovered } = this.props;

        // This component and it's existing usage is neither controlled nor
        // uncontrolled, so this incorrect usage must stand until usage can be
        // refactored
        if (disabled !== prevProps.disabled) {
            this.setState({ disabled });
        }

        if (recovered && this.state.disabled) {
            this.setState({
                disabled: false
            });
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }

    handleClick = (e) => {
        if (!this.state.disabled) {
            this.setState({ disabled: true }, () => {
                this.props.onClick(e);
                if (this.props.autoRecover) {
                    this.timeoutId = setTimeout(() => {
                        this.setState({ disabled: false });
                    }, this.props.autoRecoverTime);
                }
            });
        }
    };

    render() {
        return (
            <button
                className={`rec-button-single-click ${this.props.buttonClass}`}
                disabled={this.state.disabled}
                onClick={this.handleClick}>
                {this.props.children}
            </button>
        );
    }
}
